import React from 'react';
import './SelectionModal.css';

const SelectionModal = ({ isOpen, onClose }) => {
  if (!isOpen) return null;

  return (
    <>
      <div className="modal-overlay" onClick={onClose}></div>
      <div className="selection-modal">
        <button className="modal-close" onClick={onClose}>
          <img src="/images/closeicon.svg" alt="Close" />
        </button>
        
        <div className="modal-content">
          <div className="modal-icon">
            <img src="/images/warning.svg" alt="Warning" />
          </div>
          
          <p className="modal-message">
            Please select your language and proficiency level
          </p>
        </div>
      </div>
    </>
  );
};

export default SelectionModal;
